import { OnboardingState, SetupFeeStatus } from "../types/onboarding";
import { pipelineIndex } from "./onboardingStates";

// The fee falls due at promotion and stays relevant for the rest of the
// journey: the backlog of existing customers is invoiced long after go-live.
// Pipeline order, so the special states (RESIGNED, MORE_INFO_NEEDED) are out.
export const isCustomerPromoted = (state: OnboardingState): boolean => {
  const idx = pipelineIndex(state);
  return idx !== -1 && idx >= pipelineIndex("CUSTOMER_PROMOTED");
};

// What an agent is asked to do while a promoted customer's fee is open. The
// header's next step and the journey's "Next:" hint say the same thing.
export const SETUP_FEE_NEXT_ACTION = "Invoice the setup fee, or waive it.";

// German notation on purpose: it is what the customer's invoice says.
export const formatSetupFeeAmount = (cents: number): string =>
  `${(cents / 100).toFixed(2).replace(".", ",")} €`;

export const SETUP_FEE_STATUS_LABELS: Record<SetupFeeStatus, string> = {
  NOT_DUE: "Not due",
  OPEN: "Open",
  INVOICING: "Invoicing",
  INVOICED: "Invoiced",
  WAIVED: "Waived",
};

export const setupFeeStatusLabel = (status: SetupFeeStatus): string =>
  SETUP_FEE_STATUS_LABELS[status] ?? status;

// The filter on the prospect list and the analytics table (CWA-196 US4).
export const SETUP_FEE_STATUS_OPTIONS = (
  ["OPEN", "INVOICING", "INVOICED", "WAIVED", "NOT_DUE"] as SetupFeeStatus[]
).map((value) => ({ value, label: SETUP_FEE_STATUS_LABELS[value] }));
